import { signal } from "@preact/signals-react";
import Dialog from "componentsv2/modal/Dialog";
import { useTable } from "storev2/tableStore";

const openSignal = signal(false);

function ModalTable() {
  const { modalTable, closeModalTable } = useTable();
  const { Component, open, title, props: componentProps = {} } = modalTable;

  openSignal.value = open;

  const handleClose = () => {
    openSignal.value = false;
    closeModalTable();
  };

  return (
    <Dialog title={title} openModal={openSignal} handleClose={handleClose}>
      {Component && <Component {...componentProps} />}
    </Dialog>
  );
}

export default ModalTable;
